import { request } from './api';
import config from '../config';

export default {
  getToken (requestData) {
    return request({
      type: 'post',
      url: config.dealerWsVrapi + '/vrapi/socket/token',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify({ tokenParam: requestData }),
      xhrFields: { withCredentials: true },
      transformResponse: function (data) {
        if (data) {
          return { returncode: 0, message: '', result: data };
        } else {
          return { returncode: 1, message: '获取展厅分享海报失败', result: data };
        }
      }
    });
  }
};